import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

var IconTrackPrevious = function IconTrackPrevious(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        _ref$color = _ref.color,
        color = _ref$color === undefined ? '#999' : _ref$color,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? 14 : _ref$height,
        title = _ref.title,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? 14 : _ref$width;
    return React.createElement(
        AccessibleSVG,
        {
            className: 'icon-track-previous ' + className,
            title: title,
            width: width,
            height: height,
            viewBox: '0 0 14 14'
        },
        React.createElement('path', {
            className: 'fill-color',
            fill: color,
            d: 'M6.31 7.88l5 4.81a1 1 0 0 0 1.41 0A1 1 0 0 0 13 12V2.35a1 1 0 0 0-1-1 1 1 0 0 0-.69.28l-5 4.81a1 1 0 0 0 0 1.41zM2 1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1 1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z'
        })
    );
};

IconTrackPrevious.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    height: PropTypes.number,

    /** A text-only string describing the icon if it's not purely decorative for accessibility */
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    width: PropTypes.number
};
export default IconTrackPrevious;
import PropTypes from 'prop-types';